<script>
import { Bar } from 'vue-chartjs'
import Tools from '@/tools/tools.js'

const fmtBRL = v => Number(v || 0).toLocaleString('pt-BR', { style:'currency', currency:'BRL' })

export default {
  extends: Bar,
  name: 'GraficoBarrasClientesVendedor',
  props: {
    dt1: { type: String, default: '' },
    dt2: { type: String, default: '' },
    vendedorId: { type: [String, Number], default: '' },
    // limite de clientes exibidos (top N)
    top: { type: Number, default: 12 },
    // rotacionar rótulos pra muita coluna
    rotateLabels: { type: Boolean, default: true }
  },
  data () {
    return {
      busy: false,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        tooltips: { /* ... */ },
        scales: {
          xAxes: [{
            gridLines: { display: false },
            ticks: {
              autoSkip: false,
              // sem this.rotateLabels aqui
              callback: v => {
                const s = String(v || '')
                return s.length > 18 ? s.slice(0, 18) + '…' : s
              }
            }
          }],
          yAxes: [{ gridLines: { display: true }, ticks: { beginAtZero: true, callback: v => fmtBRL(v) } }]
        }
      },
      _ids: [] // índice -> CLIENTE_ID (pra clique)
    }
  },
  methods: {
    renderGrafico (labels, valores, qts) {
      const dataset = {
        type: 'bar',
        label: 'Valor vendido',
        backgroundColor: 'rgba(32,168,216,0.35)',
        borderColor: 'rgba(32,168,216,1)',
        borderWidth: 1.5,
        data: valores,
        _qts: qts // guardo junto p/ tooltip
      }

      const options = {
        ...this.chartOptions,
        scales: {
        ...this.chartOptions.scales,
        xAxes: [{
          ...this.chartOptions.scales.xAxes[0],
          ticks: {
            ...this.chartOptions.scales.xAxes[0].ticks,
            maxRotation: this.rotateLabels ? 45 : 0,
            minRotation: this.rotateLabels ? 45 : 0
          }
        }]
      },
        onClick: (evt) => {
          if (!this._chart) return
          let elems = []
          if (typeof this._chart.getElementsAtEventForMode === 'function') {
            elems = this._chart.getElementsAtEventForMode(evt, 'nearest', { intersect: true, axis: 'x' }, false)
          } else {
            elems = this._chart.getElementAtEvent(evt) || []
          }
          if (elems && elems.length) {
            const el  = elems[0]
            const idx = el._index
            const payload = {
              clienteId: this._ids[idx],
              nome: labels[idx],
              valor: valores[idx] || 0,
              qtVendas: qts[idx] || 0
            }
            this.$emit('abrir-cliente', payload)
          }
        },
        onHover: (evt, active) => {
          const el = evt?.target
          if (el && el.style) el.style.cursor = active && active.length ? 'pointer' : 'default'
        }
      }

      const data = { labels, datasets: [dataset] }
      if (this._chart) this._chart.destroy()
      this.$nextTick(() => this.renderChart(data, options))
    },

    async getDadosClientes () {
      this.$emit('busy', true)
      try {
        this.busy = true
        if (!this.vendedorId) {
          this._ids = []
          this.renderGrafico([], [], [])
          return
        }

        const { data: payload } = await this.$http.get('/api/protected/venda/getVendasClientesVendedorId', {
          params: { dt1: this.dt1, dt2: this.dt2, vendedorId: this.vendedorId }
        })
        const itens = Array.isArray(payload) ? payload : (payload?.data || [])

        // O endpoint já devolve ORDER BY VL_TOTAL_VENDAS DESC
        const topItems = this.top > 0 ? itens.slice(0, this.top) : itens

        const labels  = topItems.map(r => r.NOME_CLIENTE || `ID ${r.CLIENTE_ID}`)
        const valores = topItems.map(r => Number(r.VL_TOTAL_VENDAS || 0))
        const qts     = topItems.map(r => Number(r.QT_VENDAS || 0))
        this._ids     = topItems.map(r => r.CLIENTE_ID)

        this.renderGrafico(labels, valores, qts)
      } catch (e) {
        Tools.exibirMensagem(this.$store, 'Não foi possível buscar os clientes do vendedor', 'danger', e)
        this._ids = []
        this.renderGrafico([], [], [])
      } finally {
        this.busy = false
        this.$emit('busy', false)
      }
    }
  },
  watch: {
    dt1: 'getDadosClientes',
    dt2: 'getDadosClientes',
    vendedorId: 'getDadosClientes',
    top: 'getDadosClientes'
  },
  async created () { await this.getDadosClientes() },
  beforeDestroy () { if (this._chart) this._chart.destroy() }
}
</script>

<template>
  <canvas ref="canvas"></canvas>
</template>



// WEBPACK FOOTER //
// src/views/dashboard/GraficoBarrasClientesVendedor.vue